const loadingBackdropStyles = (theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    flexDirection: "column",
  },
  content: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  action: {
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& :first-child": {
      marginRight: theme.spacing(1),
    },
  },
  closeAction: {
    width: "100%",
    textAlign: "right",
    padding: theme.spacing(2),
  },
});

export default loadingBackdropStyles;
